import { render, staticRenderFns } from "./UiTableList.vue?vue&type=template&id=7764d87e&scoped=true"
import script from "./UiTableList.vue?vue&type=script&lang=js"
export * from "./UiTableList.vue?vue&type=script&lang=js"
import style0 from "./UiTableList.vue?vue&type=style&index=0&id=7764d87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7764d87e",
  null
  
)

export default component.exports